import type { PageComponent } from '../../router'
import {
	type PublicInfoPageKind,
	publicInfoPageTemplate,
} from './publicInfoPageTemplates'

/** Public store information does not require the authenticated shell. */
function createPublicInfoPage(kind: PublicInfoPageKind): PageComponent {
	return {
		mount({ containerEl }) {
			containerEl.innerHTML = publicInfoPageTemplate(kind)
			return { show() {}, hide() {}, dispose() {} }
		},
	}
}

export const PrivacyPage = createPublicInfoPage('privacy')
export const SupportPage = createPublicInfoPage('support')
